import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { UseSubscriptionMutation } from "../../actions/homeActions";
import { useEffect, useState } from "react";

export default () => {
  
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const { 
      handleSubmit, 
      control,
      watch,
      setError,
      clearErrors,
      formState: { errors },
    } = useForm({
      mode: "onSubmit", // Only validate on submit
      defaultValues: { 
        email: "", 
      },
    });

  const emailValue = watch("email");
  useEffect(() => {
      if (Object.keys(errors).length > 0) {
      }
    }, [errors]);
  const mutation = UseSubscriptionMutation(setLoading);


  const customSubmitHandler = (e) => {
    e.preventDefault();
    
    // Get current form values 
    const email = watch("email");     
    
    // Clear all previous errors
    clearErrors();
    
    let hasErrors = false;
     
    // Validate email 
    const hasEmail = email && email.trim() !== "";
    
    if (!hasEmail) {
      setError("email", {
        type: "manual",
        message: "Email is required",
      });
      hasErrors = true;
    }
    
    // Validate email format if provided
    if (hasEmail && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      setError("email", {
        type: "manual",
        message: "Please enter a valid email address",
      });
      hasErrors = true;
    }
    
    // If there are errors, stop here
    if (hasErrors) {
      return;
    }
    
    // Submit the form
    setLoading(true);
    mutation.mutate({ 
      email: email,
    });
 
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    
    // Trim values to check if they're actually empty
    const hasEmail = data.email && data.email.trim() !== "";  

    // Check if at least one of email  
    if (!hasEmail) {
      setError("email", {
        type: "manual",
        message: "Email is required",
      }); 
      return;
    }
    
    // Clear any previous conditional errors
    clearErrors("email"); 
    
    setLoading(true);
    mutation.mutate({
      email: data.email || "",
    });
  };
  return { 
    currentYear, 
    navigate, 
    isActive,
    onSubmit, 
    customSubmitHandler,
    control,
    errors,
  };
};
